/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v1.0.0 of "Info Services"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { ClientOptions } from '@api-client/base';

import { createSingleton } from '@luna/utils';

type ClientOptionsFactory = () => ClientOptions;

/**
* @description Set your default clientOptions such as
* baseUrl by calling the set() method on the factory.
*
* For example in the index.ts file of your api-client package.
* clientOptionsFactory.set(() => ({
*     baseUrl: `${getEnv().apiGatewayUrl}`,
* }));
*/
export const clientOptionsFactory = createSingleton<ClientOptionsFactory>();